import { apiClient } from './client';
import type { ComplianceControlUpdate, ComplianceSummary } from '../types';

export const complianceApi = {
  async getSummary(): Promise<ComplianceSummary> {
    const { data } = await apiClient.get<ComplianceSummary>('/compliance/summary');
    return data;
  },
  async updateControl(id: string, updates: ComplianceControlUpdate) {
    const { data } = await apiClient.patch(`/compliance/controls/${id}`, updates);
    return data.control;
  },
};
